import { Box, Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardLink = styled(Card)(({ theme }) => ({
  width: 275,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
}));

export const HelpPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  height: '100%',
  marginBottom: '10em',
}));

export const RequestSupportPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  height: '100%',
  marginBottom: '10em',
}));
